import { Ref } from 'vue';
import { DentalAndVisionApplicationStore, DentalAndVisionApplicationStoreInterface } from '@/application/shared/infrastructure/store/DentalAndVisionApplicationStore';
import { usePlocState, getStore } from '@hfc/ui-core';

interface UseDentalAndVisionApplicationStoreInterface {
  dentalAndVisionApplicationStore: DentalAndVisionApplicationStore;
  dentalAndVisionApplicationState: Ref<DentalAndVisionApplicationStoreInterface>;
}

export const useDentalAndVisionApplicationStore = (): UseDentalAndVisionApplicationStoreInterface => {
  const dentalAndVisionApplicationStore = getStore<DentalAndVisionApplicationStore>('DentalAndVisionApplicationStore', DentalAndVisionApplicationStore);
  const dentalAndVisionApplicationState = usePlocState(dentalAndVisionApplicationStore) as Ref<DentalAndVisionApplicationStoreInterface>;

  return {
    dentalAndVisionApplicationStore,
    dentalAndVisionApplicationState,
  };
};
